import {Sale} from "@/store/sale/types";
import TimeUtils from "@/utils/time-utils";

export class SaleUtils {

    public static getButtonMode(s: Sale): SaleButtonMode {
        let tillStart = Math.floor((s!.startAt - TimeUtils.getServerTimeMs()) / 1000);

        if (tillStart > 0) {
            return SaleButtonMode.TIMER_TILL_START;
        }

        let tillEnd = Math.floor((s!.endAt - TimeUtils.getServerTimeMs()) / 1000);

        if (tillEnd < 3 * 3600) {
            return SaleButtonMode.TIMER_TILL_END;
        }

        return SaleButtonMode.ACTIVE;
    }
}

export enum SaleButtonMode { TIMER_TILL_START, ACTIVE, TIMER_TILL_END }